import styled, { css } from 'styled-components';

import BaseSelect from 'Elements/Input/Select';
import BaseLabel from 'Elements/Label';

export const Wrapper = styled.div`
    ${({ theme }) => css`
        padding: 1rem 0;
        background-color: var(--bg-color, ${theme.colors.secondary.tints[1].hex});
        position: relative;
        z-index: 2;
    `}
`;

const Tab = styled.div`
    ${({ theme }) => css`
        position: absolute;
        display: flex;
        height: 2rem;
        align-items: center;
        top: -2rem;
        right: 0;
        padding: 0 1rem;
        border-radius: 0.5rem 0.5rem 0 0;

        @media ${theme.breakpoints.xlarge.media} {
            right: 1.5rem;
        }
    `}
`;

export const ClosedTab = styled(Tab)`
    ${({ theme }) => css`
        background-color: ${theme.colors.primary.hex};
        color: ${theme.colors.secondary.hex};
    `}
`;

export const ClearingTab = styled(Tab)`
    ${({ theme }) => css`
        background-color: ${theme.colors.accents[3].hex};
    `}
`;

export const Container = styled.div`
    ${({ theme }) => css`
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 1rem;
        padding: 0.5rem 0 0;

        @media ${theme.breakpoints.large.media} {
            padding: 0.5rem 0;
        }
    `}
`;

export const SelectWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-right: 1.5rem;
    max-width: 100%;
    gap: 1rem 2.5rem;
`;

export const SelectContainer = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-direction: column;
        max-width: 100%;

        @media ${theme.breakpoints.medium.media} {
            flex-direction: row;
            align-items: center;
        }
    `}
`;

export const Label = styled(BaseLabel)`
    ${({ theme }) => css`
        white-space: nowrap;
        padding-right: 0.5rem;
        font-size: 1.125rem;

        @media ${theme.breakpoints.medium.media} {
            font-size: 1.25rem;
        }
    `}
`;

export const YearSelect = styled(BaseSelect)`
    width: 10rem;
`;

export const SingleYear = styled(Label).attrs({
    as: 'span'
})`
    display: flex;
    align-items: center;
    padding-right: 0;
    font-weight: 400;
`;

export const VariantSelect = styled(BaseSelect)`
    width: 22.5rem;
    max-width: 100%;
`;
